class ConnectionRuleList {

    constructor() {

        this.rules = [];

        this.listPopup = Dialog.Popup('connection-rule', [
            this._container = div(),
            this._addButton = btn('popup-list-btn', _("ADD"))
        ], 'left-end');

        this.startDatePicker = new DatePicker('start-date-picker');
        this.endDatePicker = new DatePicker('end-date-picker');
        let daysOfWeek = [];
        this.dayOfWeekCheckboxes = [];
        this.sameTimeEveryDayCheckbox = chk();
        onEv(this.sameTimeEveryDayCheckbox, 'change', this.updateEditForm.bind(this));

        this.timeOfDayRows = [];
        this.allDayCheckboxes = [];
        this.startTimePickers = [];
        this.endTimePickers = [];
        for (let i = 0, ii = 8; i < ii; i++){

            let cb = chk();
            let stp = new TimePicker('start-time-picker');
            let etp = new TimePicker('end-time-picker');
            onEv(cb, 'change', this.updateEditForm.bind(this));

            this.allDayCheckboxes.push(cb)
            this.startTimePickers.push(stp);
            this.endTimePickers.push(etp);

            this.timeOfDayRows.push(div('stacking-row open', div('list-row', [
                span('col p30 text-right', App.WEEKDAY[i]),
                span('col p15 text-center', cb),
                span('col p20', stp.getInputElem()),
                span('col p20', etp.getInputElem())
            ])));

            if (i == 7) break;

            let cb1 = chk();
            onEv(cb1, 'change', this.updateEditForm.bind(this));
            this.dayOfWeekCheckboxes.push(cb1);
            daysOfWeek.push(label(null, [cb1, span(null, App.WD[i])]));
        }

        this.selectedRule = null;
        this.editDialog = Dialog.Modal('rule-details', _("Rule Details"), LARGE, _("SAVE"), div(null, [
            p('text-left', [span(null, _("Name: ")),this.nameField = text()]),
            p('text-left', [
                span(null, _("From: ")),
                this.startDatePicker.getInputElem(),
                span(null, _(" - To: ")),
                this.endDatePicker.getInputElem()
            ]),
            p('text-left', _("Days of the week")),
            p(null, daysOfWeek),
            p('text-left', _("Time of day: ")),
            p('text-left col-group', [
                span('col p10'),
                label(null, [this.sameTimeEveryDayCheckbox, span(null, _("Same time every day"))])
            ]),
            div('list-row', [
                span('col p30'),
                span('col p15 text-center', _("All day")),
                span('col p20 text-left', _("From")),
                span('col p20 text-left', _("To"))
            ])
        ].concat(this.timeOfDayRows)));

        onEv(this._addButton, 'click', this.addRule.bind(this));
		
		this.fetch();
    }

    fetch() {
        ajg('rules/list', null, null, this.loadData.bind(this));
    }

    loadData(reply) {
        if (reply.rules && Array.isArray(reply.rules)) {
            reply.rules.forEach(
                function (data) {
                    let rule = ConnectionRule.fromArray(data);
                    this.rules.push(rule);
                    this._container.appendChild(rule.rowElem);
                }, this
            )
        }
    }

    /**
     * Create a new rule as the edit rule before initalizing the edit form
     */
    addRule() {
        this.listPopup.close();
        this.selectedRule = new ConnectionRule();
        this.initEditForm();
        this.editDialog.open(this.updateAndSaveRule.bind(this));
    }

    /**
     * Set the selectedRule pointer to the passed rule then initialize the form
     * @param {ConnectionRule} rule 
     */
    editRule(rule) {
        this.listPopup.close();
        this.selectedRule = rule;
        this.initEditForm();
        this.editDialog.open(this.updateAndSaveRule.bind(this));
    }

    initEditForm() {
        this.nameField.value = this.selectedRule.name;
        this.startDatePicker.setDate(this.selectedRule.startDate);
        this.endDatePicker.setDate(this.selectedRule.endDate);
        let st = this.selectedRule.startTimes;
        let et = this.selectedRule.endTimes;
        this.sameTimeEveryDayCheckbox.checked = !Array.isArray(st);
        for (let i = 0, ii = 7; i < ii; i++) {
            this.dayOfWeekCheckboxes[i].checked = this.selectedRule.days & ConnectionRule.DAY_VALUE[i];
            this.allDayCheckboxes[i].checked = Array.isArray(st) ? st[i] == '-' : true;
            this.startTimePickers[i].setTime(Array.isArray(st) ? st[i] : st);
            this.endTimePickers[i].setTime(Array.isArray(et) ? et[i] : et);
        }
        this.allDayCheckboxes[7].checked = Array.isArray(st) ? true : st == '-';
        this.startTimePickers[7].setTime(Array.isArray(st) ? 8*60 : st);
        this.endTimePickers[7].setTime(Array.isArray(et) ? 18*60 : et);

        this.updateEditForm();
    }

    updateEditForm() {
        for (let i = 0, ii = 7; i < ii; i++) {
            style(this.timeOfDayRows[i], (this.dayOfWeekCheckboxes[i].checked && !this.sameTimeEveryDayCheckbox.checked) ? 'open' : 'close');
            
            let allDay = this.allDayCheckboxes[i].checked;
            this.startTimePickers[i].setEnabled(!allDay);
            this.endTimePickers[i].setEnabled(!allDay);
        }
        style(this.timeOfDayRows[7], this.sameTimeEveryDayCheckbox.checked ? 'open' : 'close');
        let allDay = this.allDayCheckboxes[7].checked;
        this.startTimePickers[7].setEnabled(!allDay);
        this.endTimePickers[7].setEnabled(!allDay);
    }

    updateAndSaveRule() {
        this.selectedRule.name = this.nameField.value;
        this.selectedRule.startDate = this.startDatePicker.getUTC();
        this.selectedRule.endDate = this.endDatePicker.getUTC();
        this.selectedRule.days = this.sumDays;
        this.selectedRule.startTimes = this.startTimes;
        this.selectedRule.endTimes = this.endTimes;
        this.selectedRule.save();
    }

    get sumDays() {
        let v = 0;
        for (let i = 0, ii = 7; i < ii; i++) {
            if (this.dayOfWeekCheckboxes[i].checked) {
                v += ConnectionRule.DAY_VALUE[i];
            }
        }
        return v;
    }

    get startTimes() {
        if (this.sameTimeEveryDayCheckbox.checked) {
            return [this.startTimePickers[7].getTime()];
        }
        let r = [];
        for (let i = 0, ii = 7; i < ii; i++) {
            if (this.dayOfWeekCheckboxes[i].checked) {
                r.push(this.startTimePickers[i].getTime());
            }
        }
        return r;
    }

    get endTimes() {
        if (this.sameTimeEveryDayCheckbox.checked) {
            return [this.endTimePickers[7].getTime()];
        }
        let r = [];
        for (let i = 0, ii = 7; i < ii; i++) {
            if (this.dayOfWeekCheckboxes[i].checked) {
                r.push(this.endTimePickers[i].getTime());
            }
        }
        return r;
    }

    /**
     * Open the list and fetch the rules that apply to the user (id in the parameters)
     * @param {int} userId 
     */ 
    show(userId, button) {
        this.mappedUser = userId;
        if (this.listPopup.handle(button)) {
            ajg('rules/map', ['userId=' + encodeURI(userId)], null, function (reply) {
                this.rules.forEach(function(rule) {
                    rule._appliedCheckbox.checked = false;
                    for (let i = 0, ii = reply.map.length; i < ii; i++) {
                        if (reply.map[i][0] == rule._id) {
                            rule._appliedCheckbox.checked = reply.map[i][1];
                            reply.map.splice(i, 1);
                            break;
                        }
                    }
                })
            }, this)
        }
    }
}